<template>
  <footer
    class="relative bg-gradient-to-br from-gray-50 via-blue-50 to-purple-50 border-t border-gray-200 mt-16 overflow-hidden"
  >
    <!-- Animated Background Elements -->
    <div class="absolute inset-0 overflow-hidden pointer-events-none">
      <div class="footer-float-shape footer-shape-1"></div>
      <div class="footer-float-shape footer-shape-2"></div>
      <div class="footer-float-shape footer-shape-3"></div>
    </div>

    <div class="container mx-auto px-4 py-12 relative z-10">
      <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
        <!-- Brand -->
        <div class="footer-section">
          <div class="mb-4">
            <img
              src="/logo-no-bg.png"
              alt="BlogDavid Logo"
              class="footer-logo"
            />
          </div>
          <p class="text-gray-700 text-base font-medium mb-4">
            Um blog, <span class="text-simple">Infinitas possibilidades</span>
          </p>
          <div class="flex items-center gap-2 text-sm text-gray-600">
            <div class="status-dot"></div>
            <span>Online e criando conteúdo</span>
          </div>
        </div>

        <!-- Links -->
        <div class="footer-section">
          <h4
            class="text-sm font-bold text-gray-900 mb-6 uppercase tracking-wider"
          >
            Links Rápidos
          </h4>
          <ul class="space-y-3">
            <li class="footer-link-item">
              <router-link to="/" class="footer-link group">
                <span class="footer-link-icon">→</span>
                <span>Início</span>
              </router-link>
            </li>
            <li v-if="authStore.isAuthenticated" class="footer-link-item">
              <router-link to="/profile" class="footer-link group">
                <span class="footer-link-icon">→</span>
                <span>Meu Perfil</span>
              </router-link>
            </li>
            <li v-if="authStore.isAuthenticated" class="footer-link-item">
              <router-link to="/saved" class="footer-link group">
                <span class="footer-link-icon">→</span>
                <span>Posts Salvos</span>
              </router-link>
            </li>
            <li v-if="authStore.isAdmin" class="footer-link-item">
              <router-link to="/admin" class="footer-link group">
                <span class="footer-link-icon">→</span>
                <span>Painel Admin</span>
              </router-link>
            </li>
          </ul>
        </div>

        <!-- Contact/Social -->
        <div class="footer-section">
          <h4
            class="text-sm font-bold text-gray-900 mb-6 uppercase tracking-wider"
          >
            Conecte-se
          </h4>
          <p class="text-gray-700 text-sm mb-6 leading-relaxed">
            Acompanhe as novidades e fique por dentro do melhor conteúdo.
          </p>
          <div class="flex gap-3">
            <a href="#" class="social-icon-link group">
              <div class="social-icon-wrapper">
                <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path
                    d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"
                  />
                </svg>
              </div>
              <span class="sr-only">Twitter</span>
            </a>
            <a href="#" class="social-icon-link group">
              <div class="social-icon-wrapper">
                <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path
                    d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"
                  />
                </svg>
              </div>
              <span class="sr-only">GitHub</span>
            </a>
            <a href="#" class="social-icon-link group">
              <div class="social-icon-wrapper">
                <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path
                    d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"
                  />
                </svg>
              </div>
              <span class="sr-only">LinkedIn</span>
            </a>
          </div>
        </div>
      </div>

      <!-- Bottom -->
      <div
        class="border-t border-gray-300 mt-10 pt-8 flex flex-col md:flex-row justify-between items-center"
      >
        <p class="text-gray-700 text-sm font-medium flex items-center gap-2">
          © {{ currentYear }} BlogDavid. Todos os direitos reservados.
        </p>
        <div class="flex gap-6 mt-4 md:mt-0">
          <a href="#" class="footer-bottom-link"> Privacidade </a>
          <a href="#" class="footer-bottom-link"> Termos </a>
          <a href="#" class="footer-bottom-link"> Contato </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { computed } from "vue";
import { useAuthStore } from "@/store/auth";

export default {
  name: "AppFooter",
  setup() {
    const authStore = useAuthStore();
    const currentYear = computed(() => new Date().getFullYear());

    return {
      authStore,
      currentYear,
    };
  },
};
</script>

<style scoped>
/* Animated Background Shapes - Simplified */
.footer-float-shape {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  opacity: 0.15;
  animation: float 25s ease-in-out infinite;
}

.footer-shape-1 {
  width: 300px;
  height: 300px;
  background: linear-gradient(135deg, #1e40af 0%, #3b82f6 100%);
  top: -150px;
  left: -100px;
}

.footer-shape-2 {
  width: 250px;
  height: 250px;
  background: linear-gradient(135deg, #3b82f6 0%, #60a5fa 100%);
  bottom: -100px;
  right: 10%;
  animation-delay: 10s;
}

.footer-shape-3 {
  width: 200px;
  height: 200px;
  background: linear-gradient(135deg, #2563eb 0%, #3b82f6 100%);
  top: 50%;
  right: -80px;
  animation-delay: 15s;
}

@keyframes float {
  0%,
  100% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(20px, -20px);
  }
}

/* Section */
.footer-section {
  opacity: 1;
}

/* Logo */
.footer-logo {
  height: 45px;
  width: auto;
  transition: opacity 0.3s ease;
}

.footer-logo:hover {
  opacity: 0.8;
}

/* Text Simple */
.text-simple {
  color: #1e40af;
  font-weight: 600;
}

/* Status Dot - Simplified */
.status-dot {
  width: 8px;
  height: 8px;
  background: #10b981;
  border-radius: 50%;
}

/* Links - Simplified */
.footer-link-item {
  opacity: 1;
}

.footer-link {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #4b5563;
  font-size: 0.875rem;
  font-weight: 500;
  transition: color 0.3s ease;
  padding: 6px 0;
}

.footer-link:hover {
  color: #2563eb;
}

.footer-link-icon {
  display: inline-block;
  transition: transform 0.3s ease;
  color: #3b82f6;
}

.footer-link:hover .footer-link-icon {
  transform: translateX(3px);
}

/* Social Icons - Simplified */
.social-icon-link {
  display: inline-block;
}

.social-icon-wrapper {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.social-icon-wrapper svg {
  transition: color 0.3s ease;
}

.social-icon-link:hover .social-icon-wrapper {
  background: #3b82f6;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.social-icon-link:hover .social-icon-wrapper svg {
  color: white;
}

/* Bottom Links - Simplified */
.footer-bottom-link {
  color: #6b7280;
  font-size: 0.875rem;
  font-weight: 500;
  transition: color 0.3s ease;
}

.footer-bottom-link:hover {
  color: #2563eb;
}
</style>
